import React, { useState, useEffect } from 'react';
import './InvoicePreview.css';

const InvoicePreview = () => {
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem('invoiceData');
    if (data) {
      setInvoiceData(JSON.parse(data));
    }
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (!invoiceData) {
    return <div className="invoice-preview"><p>Žiadne dáta na zobrazenie</p></div>;
  }

  const formatDate = (dateStr) => {
    const [year, month] = dateStr.split('-');
    const monthNames = [
      'január', 'február', 'marec', 'apríl', 'máj', 'jún',
      'júl', 'august', 'september', 'október', 'november', 'december'
    ];
    return `${monthNames[parseInt(month) - 1]} ${year}`;
  };

  // Prepočítaj total z aktuálnych dát (nie zo starého uloženého total)
  const calculateTotal = () => {
    return invoiceData.entries.reduce((sum, entry) => {
      // Použiť skutočnú cenu ak je vyplnená, inak teoretickú
      if (entry.actualInvoicePrice && entry.actualInvoicePrice > 0) {
        return sum + entry.actualInvoicePrice;
      }
      
      let itemTotal = entry.quantity * entry.unitPrice;
      
      // Pridať príplatok ak existuje (napr. pri službe "Žiadosť o vrátenie DPH zo zahraničia")
      if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
        itemTotal += 15; // Podanie +15 €
      }
      
      return sum + itemTotal;
    }, 0);
  };

  const actualTotal = calculateTotal();

  return (
    <div className="invoice-preview">
      <div className="invoice-container">
        <div className="invoice-header">
          <h1>Podklad pre fakturáciu</h1>
          <button onClick={handlePrint} className="btn-print">Tlačiť / Uložiť PDF</button>
        </div>

        <div className="invoice-content">
          <div className="invoice-info">
            <h2>Zoznam vykonaných prác pre Money S3</h2>
            <p><strong>Klient:</strong> {invoiceData.company}</p>
            <p><strong>Obdobie:</strong> {formatDate(invoiceData.period)}</p>
            <p><strong>Dátum vystavenia:</strong> {new Date().toLocaleDateString('sk-SK')}</p>
          </div>

          <table className="invoice-table">
            <thead>
              <tr>
                <th>Dátum</th>
                <th>Služba</th>
                <th>Popis</th>
                <th>Množstvo</th>
                <th>Cena/jedn.</th>
                <th>Celkom</th>
              </tr>
            </thead>
            <tbody>
              {invoiceData.entries.map((entry, index) => {
                // Použiť skutočnú cenu ak je vyplnená
                let itemTotal;
                if (entry.actualInvoicePrice && entry.actualInvoicePrice > 0) {
                  itemTotal = entry.actualInvoicePrice;
                } else {
                  // Prepočítaj total z cenníka
                  itemTotal = entry.quantity * entry.unitPrice;
                  if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
                    itemTotal += 15;
                  }
                }
                
                return (
                  <tr key={index}>
                    <td>{entry.date}</td>
                    <td>{entry.service}</td>
                    <td>{entry.description}</td>
                    <td>{entry.quantity}</td>
                    <td>{entry.unitPrice.toFixed(2)} €</td>
                    <td>{itemTotal.toFixed(2)} €</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="5" className="total-label"><strong>Celková suma:</strong></td>
                <td className="total-value"><strong>{actualTotal.toFixed(2)} €</strong></td>
              </tr>
            </tfoot>
          </table>

          <div className="invoice-notes">
            <p><em>Toto je podklad pre fakturáciu. Tieto údaje prevezmite do vášho účtovného softvéru Money S3.</em></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
